<template>
  <div class="login__section--layout" id="test">
    <div class="login__layout--navbar">
      <div class="row">
        <div class="col-6 my-auto">           
          <img class="login__logo--image--desktop" :src="logo_url" />
        </div>
        <div class="col-6 text-right my-auto">
          <a class="login__desktop--visit--web--btn" type="button" :href="web_site_url" target="_blank">
            Visit Website
          </a>
        </div>
      </div>
    </div>

    <div class="login__mobile--logo text-center">      
      <img class="login__logo--image--desktop" :src="logo_url" />
    </div>

    <div class="login-layout">
      <div class="login__header--svg"></div>
      <div class="">
        <slot/> 
      </div>
    </div>
  </div>
</template>

<script>
var Config = require("../../../router/Config");
export default {
  name: "LoginLayout",
  data() {
    return {
      logo_url: "",
      themeColor: "",
      highlight_color: "",
      web_site_url: "",
      CommonLayoutElements: {},
    };
  },
  mounted() {
    this.getLogo();
  },
  methods: {
    getLogo: function() {
      this.axios
        .post(Config.API_URL + "/api/company-logo", {
          url: document.location.origin,
          type: "front"
        })
        .then(response => {
          var result = response.data.data; 
          this.logo_url = result.logo_image;
          this.themeColor = result.theme_color;
          this.highlight_color = result.highlight_color;
          this.web_site_url = result.website;
          this.CommonLayoutElements = {
            logo_url: result.logo_image,
            themeColor: result.theme_color,
            highlight_color: result.highlight_color,
            organization_slogan: result.org_slogan,
            welcome_note: result.org_welcome_note,

          }
          document.documentElement.style.setProperty('--highlight-color', this.highlight_color);
          // Cookies.set("company_logo", result.logo_image);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style lang="scss" scoped>
:root {
  --highlight-color: #ffb319;
  --white: #ffffff; 
}
// background-color: var(--theme);
* {
  margin: 0;
  padding: 0;
}

html,
body{
   min-height: 100vh !important;
}

@media screen and (max-width: 1440px) and (min-width: 1152px) {
  .login__section--layout {
    overflow-y: auto;
  }
}

.login__section--layout {
  height: 100vh;
  background-repeat: no-repeat;
  background-color: var(--highlight-color);
}

.login-layout {
  height: 100%;
  position: relative;
}

@media (max-width: 767px) {
  .wrapper {
    margin: 10px auto;
    width: 95%;
  }

  .login__section--layout {
    height: 120%;
  }

  .login__section--layout {
    overflow: auto;
  }
}

.login__header--svg {
  background: url("../../../assets/scss/component/login/wave.svg");
  background-repeat: no-repeat;
  top: -1px;
  left: 0;
  width: 100%;
  height: 600px;
  position: absolute;
  background-size: cover;
  background-position: center;
}

/* image logo*/
.login__logo--image--desktop {
  max-width: 150px;
  max-height: 50px;
}

.login__mobile--logo {
  margin: 10px;
}

.login__desktop--visit--web--btn {
  text-decoration: none;
  padding: 10px 20px;
  font-size: 14px;
  letter-spacing: 2.5px;
  font-weight: 800;
  color: #33475b;
  background-color: #fff;
  border: none;
  transition: all 0.3s ease 0s;
  cursor: pointer;
  outline: none;
  border-radius: 0.25rem;
 box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
}

.login__layout--navbar {
  background: #fafcfe;
  display: block;
  z-index: 100;
  padding: 3rem 3rem 1rem 3rem;
}

.login__mobile--logo {
  display: none;
  z-index: 9999;
}

.login__logo--image--mobile {
  max-width: 300px;
  max-height: 400px;
  z-index: 9999;
}

@media (max-width: 767px) {
  .login__layout--navbar {
    display: none;
  }

  .login__mobile--logo {
    display: block;
    margin: -10px;
    background-color: #fafcfe;
    padding: 35px 0;
  }
}
</style>
